import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { styled } from '@mui/material/styles';
import PillSmall from '../PillSmall/PillSmall.js';

const _Counter = styled(PillSmall) `
  border-radius: 8px;
  max-width: 34px;
  ${({ theme }) => `padding: ${theme.spacing(0, 1)};`}
`;
const Counter = (_a) => {
    var { count = 0 } = _a, rest = __rest(_a, ["count"]);
    const label = useMemo(() => {
        if (count > 999) {
            return '+999';
        }
        else if (count < -999) {
            return '-999';
        }
        return count.toString();
    }, [count]);
    return jsx(_Counter, Object.assign({}, rest, { children: label }));
};

export { Counter as default };
//# sourceMappingURL=Counter.js.map
